
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("daJSk", function(module, exports) {

$parcel$export(module.exports, "LiveDocsDefaultIcon", () => $df2ed5ed7229e280$export$ccdc6546f7bb16f7);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $Qlykt = parcelRequire("Qlykt");
const $df2ed5ed7229e280$var$primaryColor = "var(--ds-text-subtle, #44546F)";
const $df2ed5ed7229e280$var$backgroundColor = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $df2ed5ed7229e280$var$containerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.025'
});
const $df2ed5ed7229e280$export$ccdc6546f7bb16f7 = ({ size: size, label: label, testId: testId })=>{
    if (size === (0, $Qlykt.EMOJI_SIZE_MEDIUM) || size === (0, $Qlykt.EMOJI_SIZE_LARGE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $df2ed5ed7229e280$var$containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        "data-testid": testId,
        width: size,
        height: size,
        "aria-label": label,
        role: "img",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        width: "80",
        height: "80",
        rx: "16",
        fill: $df2ed5ed7229e280$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fill: $df2ed5ed7229e280$var$primaryColor,
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 24.0124H61.7824V19H15V24.0124ZM15 40.7204H31.708V35.708H15V40.7204ZM15 59.0992H31.708V54.0868H15V59.0992ZM44.4708 36.887C43.5506 36.5419 42.5136 36.7665 41.8187 37.4615C41.1237 38.1564 40.8991 39.1934 41.2442 40.1136L48.3328 59.0166C48.7164 60.0395 49.7185 60.6961 50.8096 60.6394C51.9007 60.5826 52.8293 59.8256 53.1047 58.7684L54.9286 51.767C55.0812 51.1813 55.5385 50.7239 56.1242 50.5714L63.1256 48.7475C64.1828 48.4721 64.9399 47.5435 64.9966 46.4524C65.0534 45.3613 64.3968 44.3592 63.3738 43.9756L44.4708 36.887Z"
    })));
    return null;
};

});


//# sourceMappingURL=LiveDocsDefaultIcon.d44543de.js.map
